// Shared free-tier gate copy (expansion date window, signal blur, API keys).
export default {
  premium: {
    tag: "会员",
    gate: {
      signalsTitle: "最新的 {n} 条信号已锁定",
      signalsDesc: "升级即可查看每家公司自始至今的全部扩张信号。",
      signalsCta: "解锁信号",
    },
    dateWindow: {
      tip: "免费版仅支持最近 {n} 天。升级可查看完整历史。",
      lockedLabel: "升级以查看完整历史",
    },
    apiKeys: {
      bannerTitle: "API 访问为付费功能",
      bannerDesc: "生成密钥、自动导出，并以编程方式查询 Pubrio。",
      tip: "升级套餐即可创建 API 密钥。",
      cta: "查看套餐",
    },
    team: {
      locked: "查看团队",
      tip: "升级即可查看该市场的本地团队。",
    },
    source: {
      locked: "查看来源",
      tip: "升级即可打开每条信号背后的来源。",
    },
    employees: {
      locked: "员工数据已锁定",
      tip: "升级即可查看该公司的人数与相关人员。",
      cta: "解锁员工",
    },
    markets: {
      moreLocked: "+{n} 个更多市场",
    },
  },
};
